import React from 'react'
import ReactPaginate from 'react-paginate'
import './Pagination.css'
import '../../../Airoom.css'
import Select, { StylesConfig } from "react-select";
// import Select from 'react-dropdown-select'
interface props {
    totalResult?: any
    toResult?: any
    ofResult?: any
    onChange?: (selectedOption: any) => void;
    pageSize?: any
    onPageChange?: any
    pageCount?: any
    forcePage?: number;
}
const Pagination = ({ totalResult, toResult, ofResult, onChange, pageSize, onPageChange, pageCount, forcePage }: props) => {


    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    const options1 = [
        { value: 15, label: "15" },
        { value: 30, label: "30" },
        { value: 45, label: "45" },
        { value: 60, label: "60" },
    ];

    return (
        <>
            <div className="d-flex flex-stack flex-wrap pt-10 align-items-center justify-content-between mt-2">
                {/* <div className="fs-6 fw-bold text-gray-700 d-flex gap-2 mt-2">
                    <span>showing</span>
                    <span>{totalResult}</span>
                    <span>to</span>
                    <span>{toResult}</span>
                    <span>of</span>
                    <span>{ofResult}</span>
                    <span>entries</span>
                </div> */}
                <div className='d-flex align-items-center '>
                    <label className='wrap me-2'>Per Page</label>
                    <Select
                        styles={customStyles}
                        options={options1}
                        value={options1.find(option => option.value === pageSize)}
                        className='select width'
                        onChange={onChange}
                    />
                    {/* <select value={pageSize} className='form-select form-select-solid h-40px w-80px' onChange={onChange}>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="30">30</option>
                            <option value="100">100</option>
                        </select> */}

                </div>

                <div className='d-flex align-items-center gap-3 overflow-auto'>

                    <ReactPaginate
                        breakLabel={"..."}
                        nextLabel="Next"
                        onPageChange={(e) => onPageChange(e)}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={1}
                        pageCount={pageCount}
                        forcePage={forcePage}
                        previousLabel="Previous"
                        containerClassName='pagination'
                        pageClassName='page-item'
                        previousClassName='page-item'
                        nextClassName='page-item'
                        breakClassName='page-item'
                        pageLinkClassName='page-link'
                        previousLinkClassName='page-link'
                        nextLinkClassName='page-link'
                        breakLinkClassName='page-link'
                        activeClassName='active'
                    />
                </div>
            </div>
        </>
    )
}

export default Pagination